"use client"
import { Card } from "@/components/ui/card";
import Styles from "./Cards.module.css";
import Image from "next/image";
import Link from "next/link";
// import { convertToWebp } from "../../utils/Images/utlToWebp";
// import LoaItemOrdersder from "../Loader/Loader";
import { useNow, useFormatter } from "next-intl";
import { Calendar } from "lucide-react";

// import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
export default function ContentCards({
  imgSrc,
  Category,
  title,
  date,
  categories_slug,
  slug,
  categories_id,
  parent,
  id,
}) {
  // console.log(slug, id, "posts id");
  const BaseLink = "/storage/" + imgSrc;
  // const format = useFormatter();
  const dateTime = new Date(date);
  // const now = useNow({
  //   // … and update it every 10 seconds
  //   updateInterval: 1000 * 10,
  // });
  return (
    <Card
      className={Styles.CardsContainer}
      style={{ width: "100%", height: "500px" }}
    >
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        <Image
          // component="img"
          // height="140"
          className={Styles.CardsImage}
          // width={500}
          // height={500}
          fill
          sizes="100vw"
          quality={30}
          // loader={Loader}
          src={BaseLink}
          // fall
          overrideSrc="/img/logo.png"
          alt="green iguana"
          style={{
            // width: "100%",
            // maxWidth: "700px",
            // height: "auto",
            objectFit: "cover",
          }}
        />
      </div>
      <div className={Styles.CardsContentF}>
        <div className={Styles.textContainer}>
          {parent ? (
            <Link
              href={`/${encodeURIComponent(
                categories_slug
              )}?id=${categories_id}&limit=0`}
            >
              <div className={Styles.CategorySections}>
                <span>{Category}</span>
              </div>
            </Link>
          ) : (
            <></>
          )}

          {/* < href={""}> */}
          <div className={Styles.titleContainer}>
            {/* <h3>{LongText(title, 50)}</h3> */}
            <Link
              href={`/${encodeURIComponent(
                categories_slug
              )}/${encodeURIComponent(slug)}?id=${id}`}
            >
              <span className={Styles.title}>{title}</span>
            </Link>
          </div>
          <Link href={""}>
            <div className={Styles.dateSections}>
              <Calendar />
              {/* <span>{format.relativeTime(dateTime, now)}</span> */}
            </div>
          </Link>
          <div className="">
            <span></span>
          </div>
        </div>
      </div>
    </Card>
  );
}
